<div class="render-flow is-cream render-flow--dialog">
  <aside *ngIf="job" class="order-card pack-card pack-card--dialog" aria-labelledby="render-pack-title" app-render-pack-card [job]="job"></aside>
  <button class="pack-dialog__close" type="button" aria-label="Close" (click)="onClose()">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1.5 1.5l11 11M12.5 1.5l-11 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
  </button>
</div>
